import React from 'react';
import { TipsMapType, TipsMapFunType } from '../index';
import DBO_FWC from '@op/hooks/useFrontWebConfig';
import ChannelLabel from '@op/components/ChannelLabel';
export const urlDrillUrlHeaderTips: TipsMapFunType = (time: string) => ({
  zh: `本报告基于 ${time} 从网络上爬取的内容生成。`,
  en: `This report is based on the content scraped on ${time}.`,
});

export const keywordDrillUrlHeaderTips: TipsMapFunType = (time: string) => ({
  zh: `AI总结报告基于${time}提交的舆情筛选内容分析获得。`,
  en: `The AI summary report is based on the content submitted at ${time}.`,
});

export const keywordDrillUrlExtendedSearchTips: TipsMapType = {
  zh: (
    <>
      拓展搜索：通过输入的关键词，系统将智能联想到包括合成词、同义词及跨语言相关词汇在内的多种变体，以实现更全面的搜索覆盖。
      <br />
      示例：当输入“good”时，系统将检索包含“good”、“nice”、“great”、“好”、“جيد”（阿拉伯语）、“いい”（日语）、“좋다”（韩语）等词的相关评论。
      <br />
      注：拓展搜索当前仅支持【或】搜索，即“；”符号的输入。
    </>
  ),
  en: (
    <>
      Extended Search: By entering a keyword, the system will associate it with
      various forms, including compound words, synonyms, and
      cross-language-related terms to achieve broader search coverage.
      <br />
      Example: Upon inputting “good”, the system will retrieve relevant reviews
      containing “good”, “nice”, “great”, “好” (Chinese), “جيد” (Arabic), “いい”
      (Japanese), “좋다” (Korean), and more.
      <br />
      Note: The extended search currently only supports the "OR" search, which
      is the input of the ";" symbol.
    </>
  ),
};

export const keywordDrillUrlExactSearchTips: TipsMapType = {
  zh: (
    <>
      精准搜索：通过键入文本去匹配评论的原文、英译和中译。排除所有非指定词汇的干扰。
      <br />
      例如，若用户输入“good”，则系统只会显示命中了“good”一词原文、中文、英文的评论，而不会命中如“better”等其他相关词汇。
    </>
  ),
  en: (
    <>
      Exact Search: When we enter a keyword, the system will precisely match it
      in the original text, English translation, and Chinese translation of the
      reviews, excluding unrelated terms.
      <br />
      For instance, if we enter "good," the system will only display reviews
      containing the exact word "good" in any of these versions, without
      including related terms like "better."
    </>
  ),
};

export const keywordDrillUrlFilteredReviewsTips: TipsMapType = {
  zh: <>基于上方输入的关键词和筛选器条件，筛选出的评论数量。</>,
  en: (
    <>
      The number of reviews filtered based on the keywords entered and the
      filters selected above.
    </>
  ),
};

export const keywordDrillUrlFilteredReviewsMentionsTips: TipsMapType = {
  zh: (
    <>
      根据所输入的关键词及选用的筛选器条件，计算筛选评论数量占所选时间段内总评论量的比例。
    </>
  ),
  en: (
    <>
      Calculate the proportion of filtered reviews out of the total reviews
      mention within the selected time range, based on the entered keywords and
      chosen filters.
    </>
  ),
};

export const keywordDrillUrlFilteredReviewsEngagementTips: TipsMapType = {
  zh: <>根据所输入的关键词及选用的筛选器条件，计算筛选评论的互动量总计。</>,
  en: (
    <>
      Calculate the total Engagement of filtered reviews, based on the entered
      keywords and the chosen filters.
    </>
  ),
};

export const keywordDrillUrlMobileFilteredReviewsTips: TipsMapType = {
  zh: (
    <>
      基于上方输入的关键词和选用的筛选器条件，筛选出的 Google/AppStore
      评论数量。
    </>
  ),
  en: (
    <>
      The number of Google/AppStore reviews filtered based on the keywords
      entered and the chosen filters.
    </>
  ),
};

export const keywordDrillUrlMobileFilteredReviewsRatingTips: TipsMapType = {
  zh: (
    <>
      所选筛选条件内（包括关键字、日期、国家、情感分等其他筛选器），所有评论评分值求平均。
    </>
  ),
  en: (
    <>
      Average the ratings of all reviews for the selected filter (including
      Keywords, Date, Region/Country, Sentiment, and other filters).
    </>
  ),
};

export const keywordDrillUrlSteamFilteredReviewsRatingTips: TipsMapType = {
  zh: <>基于上方输入的关键词和所选用的筛选条件，筛选出的Steam评论数量。</>,
  en: (
    <>
      The number of Steam reviews filtered based on the keywords entered and the
      filters selected.
    </>
  ),
};

export const keywordDrillUrlRatingChartTips: TipsMapType = {
  zh: (
    <>
      本图表展示了基于【筛选条件下所有评论】和【仅日期筛选条件下的所有评论】两种条件下各语种商店的评分分数，并通过右侧“评分差值”坐标轴显示这两种条件下的评分差异。
    </>
  ),
  en: (
    <>
      This chart displays the rating of reviews in various languages based on
      two conditions: [filtered reviews] and [all reviews of the selected date].
      It also shows the rating differences between these two conditions via the
      "Rating Difference" axis on the right side.
    </>
  ),
};

export const keywordDrillUrlRatingDifferenceTips: TipsMapType = {
  zh: <>筛选后评论的平均评分 - 所选日期所有评论的平均评分 </>,
  en: (
    <>
      Average rating of filtered reviews - Average rating of all reviews of the
      selected date
    </>
  ),
};

export const keywordDrillUrlRatingDifferenceYAxixTips: TipsMapType = {
  zh: <>好评率差值 = 筛选后评论的Steam好评率 - 所选日期所有评论的Steam好评率</>,
  en: (
    <>
      Positive% difference = Steam Positive% of filtered reviews - Steam
      Positive% of all reviews of the selected date
    </>
  ),
};

export const keywordDrillUrlMobileDifferenceYAxixTips: TipsMapType = {
  zh: <>评分差值 = 筛选后评论的平均评分 - 所选日期商店评论的平均评分</>,
  en: (
    <>
      Rating Difference = Average Rating of Filtered Reviews - Average Rating of
      Game Store Reviews of the selected date
    </>
  ),
};

export const keywordDrillUrlPositiveRatioByLanguageTips: TipsMapType = {
  zh: (
    <>
      本图表展示了【筛选条件下所有评论】和【仅日期筛选条件下的所有评论】两种条件下各语种商店的Steam好评率，并通过右侧“评分差值”坐标轴显示这两种条件下的评分差异。
    </>
  ),
  en: (
    <>
      This chart displays the Positive% of steam reviews in various languages
      based on two conditions: [filtered reviews] and [all reviews of the
      selected date]. It also shows the Positive% differences between these two
      conditions via the "Positive% Difference" axis on the right side.
    </>
  ),
};

export const keywordDrillUrlLoadingTips: TipsMapType = {
  zh: <>加载数据后，可以下载报告图像。</>,
  en: <>After the data is loaded, the report image can be downloaded.</>,
};

export const keywordDrillUrlShortcutKeywordTips: TipsMapFunType = (
  keywordList: Array<string>,
) => ({
  zh: (
    <>
      点击后，下方输入框将填入快捷选项：
      <br />
      {keywordList}
    </>
  ),
  en: (
    <>
      After clicking the shortcut, the input box will be populated with the
      following predefined options:
      <br />
      {keywordList}
    </>
  ),
});

export const keywordDrillUrlCommentsGptTips: TipsMapType = {
  zh: <>从上方指定的URL获取帖子评论内容，并进行总结归纳。</>,
  en: (
    <>
      Scrape the comment content from the URL above, and perform a summary
      analysis.
    </>
  ),
};

export const keywordDrillUrlFormItemTips: TipsMapType = {
  zh: (
    <>
      某些URL的评论默认情况下不会被采集。通过点击【生成分析】按钮，DataBrain将自动触发对输入URL的评论采集和分析任务。请耐心等待。
    </>
  ),
  en: (
    <>
      Comments for some URLs are not scraped by default. By clicking ‘Generate
      Analysis’, DataBrain will automatically trigger comment scraping and
      analysis tasks for the entered URLs. Please wait patiently.
    </>
  ),
};

export const keywordDrillUrlFailedTips: TipsMapType = {
  en: (
    <>
      Task generation failed, possibly due to the following reasons:
      <br />
      1. Incorrect link <br />
      2. The crawler does not currently support scraping this link <br />
      3. The crawler is unable to retrieve the necessary content for a summary
      from this link
    </>
  ),
  zh: (
    <>
      任务创建失败，可能由于以下原因导致：
      <br />
      1. 链接错误
      <br />
      2. 爬虫暂不支持爬取该链接
      <br />
      3. 该链接爬虫无法获取总结所需内容
    </>
  ),
};

export const keywordDrillUrlViewsTips: TipsMapType = {
  en: (
    <>
      The data is sourced from Levelup and only displays the Views data for
      dates that have been collected so far. Some posts' daily Views data may be
      incomplete (due to not being regularly retrieved).
      <br />
      Additionally, if certain URLs' channels do not appear in the chart, it is
      because Levelup has not yet covered the data for those channels.
      <br />
      The trend chart below will display the Views data of the post from the
      posting time to the selected end time.
    </>
  ),
  zh: (
    <>
      数据来源于Levelup，仅支持展示当前已收录日期的观看量数据，部分帖子按日的观看量数据可能不全（未例行获取）。
      <br />
      此外，如果某些URL渠道未出现在图表中，是因为Levelup尚未覆盖这些渠道的数据。
      <br />
      下方趋势图将显示帖子从发帖时间至所选结束时间的观看量数据。
    </>
  ),
};

export const keywordDrillUrlAddedCommentTips: TipsMapType = {
  en: (
    <>
      Aggregate the crawled comments (including subtitles) within the selected
      time range. <br />
      The trend chart below will display the Added Comment Count of the post
      from the posting time to the selected end time.
    </>
  ),
  zh: (
    <>
      根据所选时间范围汇总爬取的评论（包括弹幕）。 <br />
      下方趋势图展示帖子从发帖时间至所选结束时间的新增评论数据。
    </>
  ),
};

export const keywordDrillUrlPostEngagementTips: TipsMapType = {
  en: (
    <>
      Calculate the engagement of the post scraped from the specified URL,
      including the total of likes, dislikes, comments, and shares.(Only latest
      data are available)
    </>
  ),
  zh: (
    <>
      统计从指定URL爬取的主贴互动量，其中互动量包括点赞、点踩、评论以及分享的总和。（仅可提供爬取的最新数据）
    </>
  ),
};

export const keywordDrillUrlCommentsEngagementTips: TipsMapType = {
  en: (
    <>
      Calculate the Engagement volume within the selected time range for
      comments on posts crawled from the specified URL. Comment engagement
      volume includes the total sum of comments, likes/dislikes on comments,
      replies to comments, and likes/dislikes on comment replies, used to
      analyze player activity in the comment section and overall sentiment
      tendency.
      <br />
      <br />
      Positive Ratio: The proportion of positive sentiment comments and their
      like counts.
      <br />
      Negative Ratio: The proportion of negative sentiment comments and their
      like counts.
    </>
  ),
  zh: (
    <>
      统计从指定URL爬取的帖子评论的所选时间范围互动量，评论互动量统计包含评论及评论点赞/踩、评论回复及评论回复点赞/踩的总和，用于分析评论区玩家的活跃情况以及整体情感倾向。
      <br />
      <br />
      正面占比：情感分为正面的评论及其点赞数的占比；
      <br />
      负面占比：情感分为负面的评论及其点赞数的占比。
    </>
  ),
};

export const keywordDrillUrlViewsTimeTips: TipsMapType = {
  en: (
    <>
      Since the historical Views data for the selected time range cannot be
      obtained, the latest data is displayed here for your reference.
    </>
  ),
  zh: (
    <>
      由于所选时间范围内的观看量历史数据无法获取，此处展示最新的数据以供参考。
    </>
  ),
};

export const keywordDrillUrlPostEngagementTimeTips: TipsMapType = {
  en: (
    <>
      Since the historical Post Engagement data for the selected time range
      cannot be obtained, the latest data is displayed here for your reference.
    </>
  ),
  zh: (
    <>
      由于所选时间范围内的主贴互动量历史数据无法获取，此处展示最新的数据以供参考。
    </>
  ),
};

function getUrlList(
  list: { channel: string; tips_en: string; tips_zh: string }[],
  key: 'tips_en' | 'tips_zh',
) {
  if (list.length > 0) {
    return (
      <>
        {list.map(({ channel, ...tipsMap }: any) => {
          const tips = tipsMap[key];

          return (
            <p
              key={channel}
              style={{ lineHeight: '14px', height: 14, marginTop: 10 }}
            >
              <ChannelLabel
                style={{ height: 14 }}
                iconStyle={{ width: 16, height: 16 }}
                textStyle={{ marginLeft: 5 }}
                channel_name={channel}
              ></ChannelLabel>{' '}
              {tips && `(${tips})`}
            </p>
          );
        })}
      </>
    );
  }

  return null;
}

export const keywordDrillUrlVideoContentSummary: TipsMapFunType = () => {
  const list = DBO_FWC.get('have_video_ai_channel');

  return {
    en: (
      <>
        Process video content by scraping subtitles or performing ASR (Automatic
        Speech Recognition) transcription, then generate summaries.
        <br /> Supports videos from the following channels：
        <br />
        {getUrlList(list, 'tips_en')}
      </>
    ),
    zh: (
      <>
        通过抓取字幕或执行自动语音识别（ASR）转录处理视频内容，随后生成摘要。
        <br />
        支持以下平台的视频：
        <br />
        {getUrlList(list, 'tips_zh')}
      </>
    ),
  };
};

export const keywordDrillUrlVideoLiveStreamContentSummary: TipsMapFunType =
  () => {
    const list = DBO_FWC.get('have_video_danmuku_ai_channel');

    return {
      en: (
        <>
          Generate a summary by scraping live stream comments
          <br /> Supports summary from the following channels：
          <br />
          {getUrlList(list, 'tips_en')}
        </>
      ),
      zh: (
        <>
          通过抓取弹幕生成摘要。
          <br />
          支持以下平台弹幕总结：
          <br />
          {getUrlList(list, 'tips_zh')}
        </>
      ),
    };
  };

export const keywordDrillUrlPreviewsDisabledTips: TipsMapType = {
  en: (
    <>
      Report is being generated. Data filtering will be available after
      completion
    </>
  ),
  zh: <>报告处理中，完成后即可筛选数据</>,
};

export const keywordDrillUrlTopicAnalysisTips: TipsMapType = {
  en: (
    <>
      Please enter the <b>topic name</b> and its corresponding <b>definition</b>{' '}
      here. These two fields are compulsory. Additionally, you may choose to
      provide some keywords and example sentences related to the topic; these
      two fields are optional.
      <br />
      When defining a topic, follow the logic of &quot;[<b>Topic Name</b>] + [
      <b>What it&apos;s about. &lt;Exclude&gt; Unwanted Content</b>] + [<b>Real examples/keywords</b>]&quot; to
      help the system identify it more accurately.
      <br />
      <br />
      Multiple topics format: <br />
      Topic 1: [Topic Name] + [What it&apos;s about] + [Real examples/keywords]
      <br />
      Topic 2: [Topic Name] + [What it&apos;s about] + [Real examples/keywords]
      <br />
      Topic 3: [Topic Name] + [What it&apos;s about] + [Real examples/keywords]
    </>
  ),
  zh: (
    <>
      请输入<b>话题名称</b>和<b>话题定义</b>
      ，这两项为必填字段。此外，您可以选择提供相关的关键词和示例句子，这两项为可选字段。
      <br />
      定义话题时，请遵循&quot;[<b>话题名称</b>] + [<b>话题内容。&lt;排除&gt;内容</b>] + [
      <b>实际案例/关键词</b>]&quot;的逻辑，以帮助系统更准确地识别。
      <br />
      <br />
      多话题格式：
      <br />
      Topic 1: [话题名称] + [话题内容] + [实际案例/关键词]
      <br />
      Topic 2: [话题名称] + [话题内容] + [实际案例/关键词]
      <br />
      Topic 3: [话题名称] + [话题内容] + [实际案例/关键词]
    </>
  ),
};

export const KeywordTopicPreviewsTaggedTips: TipsMapType = {
  en: (
    <>
      This page displays all historically tagged data. For the latest progress
      of routine tasks, please refer to &quot;Latest Analysis Task Progress&quot;.
    </>
  ),
  zh: (
    <>
      当前页面展示历史所有已打标数据，最新例行任务进展请查看「最新分析任务进程」。
    </>
  ),
};

export const KeywordTopicCopyCurrentReportTips: TipsMapType = {
  en: 'Copy Report link with current selected filters',
  zh: '复制报告的当前选项'
};

export const KeywordTopicCopyOriginalReportTips: TipsMapType = {
  en: 'Copy Report link with original filters',
  zh: '复制报告的初始选项'
};